var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"back-button",attrs:{"elevation":"0"},on:{"click":_vm.handler}},[_c('SvgIcon',{attrs:{"text":_vm.text},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('BackIcon')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }